import { PreloadJob } from '../../../UnicronApp/preloader/PreloadJob';
import { EvalResult } from '../../services/FlagrService/types';
import { FlagrEvaluationSlot } from './FlagrEvaluationSlot';

export const preloadFlagrEvaluation = async (
  job: PreloadJob,
  flagKeys: string[],
  entityIds: string[],
) => {
  const { services } = job;

  try {
    const evaluationBatch = await services.flagr.evaluateBatch(flagKeys, entityIds, true);
    const completeMap = makeMap(evaluationBatch, job, flagKeys);

    services.cache.set(FlagrEvaluationSlot, completeMap);
  } catch {
    services.cache.set(FlagrEvaluationSlot, makeMap([], job, flagKeys));
  }
};

const makeMap = (
  evaluationBatch: EvalResult[],
  job: PreloadJob,
  flagKeys: string[],
): Record<string, EvalResult> => {
  const { services } = job;
  const initalValue: Record<string, EvalResult> = {};

  const evalMap = evaluationBatch.reduce((acc, evalResult) => {
    if (evalResult.flagKey) acc[evalResult.flagKey] = evalResult;
    return acc;
  }, initalValue);

  const emptyMap: Record<string, EvalResult> = {};

  const completeMap = flagKeys.reduce((acc, key) => {
    const flagValue = services.flags[key];
    acc[key] = evalMap[key] ?? { variantKey: flagValue ? 't' : undefined };

    return acc;
  }, emptyMap);

  return completeMap;
};
